import script from "./cpu-brand-distribution-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./cpu-brand-distribution-chart.vue?vue&type=script&lang=ts&setup=true"

import "./cpu-brand-distribution-chart.vue?vue&type=style&index=0&id=9cce83fa&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cce83fa"]])

export default __exports__